// extracted by mini-css-extract-plugin
export default {"answer":"D9-z","bestAnswerHeading":"E9-z","meta":"F9-z"};